import { path } from 'ramda';
import { IOfferState } from '../../redux/reducers';

/**
 *
 * @description Возвращает id дома из ЖК
 */
export function getJKHouseId(offer: IOfferState): number | undefined {
  return path<number>(['geo', 'jk', 'house', 'id'], offer);
}
